import React from 'react';
import cn from 'classnames';
import style from './footer.mod.scss';
import Container from '../layout/container/container';
import Logo from '../logo/logo';
import Divider from '../../components/divider/divider';
import Button from '../button/button';

const Footer = () => {
  const classes = cn(style.footer);

  return (
    <div id="footer" className={classes}>
      <Container gutters>
        <div className={style.footer__content}>
        <div className={style.footer__logo}>
          <Logo />
        </div>
        <div className={style.footer__strive}>
          <div>Copyright © 2024</div>
        </div>
        </div>
      </Container>
    </div>
  );
};

export default Footer;